import { render, staticRenderFns } from "./trello_card.vue?vue&type=template&id=3da02a6f&scoped=true&"
import script from "./trello_card.vue?vue&type=script&lang=js&"
export * from "./trello_card.vue?vue&type=script&lang=js&"
import style0 from "./trello_card.vue?vue&type=style&index=0&id=3da02a6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da02a6f",
  null
  
)

export default component.exports